<template>
  <LayoutDashboard title="Modelos de Tanques">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarModeloTanque()"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-modelo-tanque')"
          >Cadastrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field
          outlined
          dense
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
        >
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="getModelosTanques"
          :search="search"
          dense
        >
          <template v-slot:item.action="{ item }">
            <TooltipButton
              @click.native="visualizarModeloTanque(item)"
              classButton="ml-2"
              subtitle="Visualizar"
              icon="search"
              color="primary"
              v-if="$helper.verificaPermissao('visualizar-modelo-tanque')"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <ModalCadastroModeloTanque />
  </LayoutDashboard>
</template>

<script>
import ModalCadastroModeloTanque from "@/pages/modeloTanque/ModalCadastro";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ModalCadastroModeloTanque,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "#", value: "id" },
        { text: "Modelo", value: "modelo" },
        { text: "", value: "action", sortable: false },
      ],
      funcionarios: [],
    };
  },
  computed: {
    ...mapGetters(["getModelosTanques"]),
  },
  methods: {
    ...mapActions([
      "listarModeloTanque",
      "visualizarModeloTanque",
      "cadastrarModeloTanque",
      "setModalCadastroModeloTanque",
    ]),
  },
  created() {
    this.listarModeloTanque();
  },
};
</script>